const logs = {
	title: "Logger",
	details: "Log Details",
	id: "ID",
	user_id: "Bruker",
	action: "Hendelse",
	action_model: "Hendelsestype",
	action_id: "Hendelses ID",
	record: "Registrering",
	ip_address: "IP adresse",
	created_at: "Dato",
	field: "Field",
	before_values: "Before Values",
	after_values: "After Values",
};
export default logs;